import { render, staticRenderFns } from "./styles.vue?vue&type=template&id=4b853bdb"
import script from "./styles.vue?vue&type=script&lang=js"
export * from "./styles.vue?vue&type=script&lang=js"
import style0 from "./styles.vue?vue&type=style&index=0&id=4b853bdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports